import parsePhoneNumberFromString from 'libphonenumber-js';

/** Returns true when `value` is a valid E.164 phone string (e.g. `+250781234567`). */
export function isValidE164Phone(value: string): boolean {
  return parsePhoneNumberFromString(value)?.isValid() ?? false;
}
